import { render, staticRenderFns } from "./checkbox-button.component.vue?vue&type=template&id=42dbc35e"
import script from "./checkbox-button.component.ts?vue&type=script&lang=ts&external"
export * from "./checkbox-button.component.ts?vue&type=script&lang=ts&external"
import style0 from "./checkbox-button.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports